import React, {useState} from 'react';
import styles from './HowItWorksPoints.module.scss';
import Guarantee from '../guarantee';
import LazyImage from 'gui/components/LazyImage/LazyImage';
import {openCrispChat} from 'gui/components/crispChat';
import {Collapse} from '@material-ui/core';

interface IPointsProps {
  className?: string;
  pointIcon?: any;
  points?: string[];
}

const HowItWorksPoints = (props: IPointsProps) => {
  const [checked, setChecked] = useState(false);
  return (
    <div className={props.className}>
      <Guarantee className={styles.howItWorks}
                 onClick={() => setChecked(!checked)}
                 iconComponent={<LazyImage src={'/img/guranteeQuestion.png'}
                                           title={'questions'}/>}>
        איך זה עובד
      </Guarantee>
      <Collapse in={checked} className={styles.points}>
        {props.points.map((point, index) => <Guarantee key={point} className={styles.point}
                                                       iconComponent={props.pointIcon}>
          {point}
        </Guarantee>)}
        <Guarantee className={`${styles.point} ${styles.pointSupportLink}`}
                   iconComponent={<LazyImage src={'/img/guranteeOk.png'} style={{opacity: 0}} title={'point'}/>}
                   onClick={openCrispChat}
        >
          עדיין יש שאלות? אנחנו פה
        </Guarantee>
      </Collapse>
    </div>
  );
};

HowItWorksPoints.defaultProps = {
  className: undefined,
  points: [],
};

export default React.memo(HowItWorksPoints);
